export const ROUTE_OPTIONS = [
  { label: "Aural", value: "Aural" },
  { label: "Inhalation", value: "Inh" },
  { label: "Intramuscular", value: "IM" },
  { label: "Intranasal", value: "Intranasal" },
  { label: "Intravenous", value: "IV" },
  { label: "PO", value: "PO" },
  { label: "PR", value: "PR" },
  { label: "PV", value: "PV" },
  { label: "Subcutaneous", value: "SC" },
  { label: "Sublingual", value: "Sublingual" },
  { label: "Topical", value: "Top" },
];

export const FREQUENCY_OPTIONS = [
  { label: "STAT", value: "STAT" },
  { label: "OD - Once Daily", value: "OD" },
  { label: "BD - Twice Daily", value: "BD" },
  { label: "Three times daily", value: "TDS" },
  { label: "Four times daily", value: "QDS" },
  { label: "As required", value: "PRN" },
  { label: "Once Weekly", value: "Once Weekly" },
  { label: "Twice Weekly", value: "Twice Weekly" },
  { label: "Three time weekly", value: "Three time weekly" },
];

export const ROUTE_LABEL = (value) =>
  ROUTE_OPTIONS.find((o) => o.value === value)?.label ?? value;

export const FREQUENCY_LABEL = (value) =>
  FREQUENCY_OPTIONS.find((o) => o.value === value)?.label ?? value;
